<template>
  <div class="download-btn-box download-btn-box-big">



    <div class="download-btn" v-bind:class="{ 'disabled': processingDownload === true || currentJob.state === 'failed' || currentJob.state === 'not_found'}"
   >
      <a class="d-flex gap-10px align-items-center download-btn-main download-btn-primary"  @click="downloadJob" :href="downloadLink">
      <i v-if="!processingDownload" class="far fa-download"></i>
      <i v-if="processingDownload" class="fa fa-spin btn-loading-animation"></i>
      {{ 'Download' | trans }}
      </a>
      <div class="download-btn-dropdown" @click="dropdownActive = !dropdownActive">
        <i class="far fa-chevron-down" v-if="!dropdownActive"></i>
        <i class="far fa-chevron-up" v-if="dropdownActive"></i>
      </div>

      <div id="download-dropdown" class="" v-if="dropdownActive && currentJob.state !== 'failed' && currentJob.state !== 'not_found' && currentJob.state !== 'processing'">

        <div class="dropdown-item">
          <span
              id="dropboxButton"
              title="Download as ZIP"
              class="px-0 cursor-pointer dropdown-item d-flex text-indent-0 white-space-normal align-items-center"
              @click.prevent="downloadJobAsZip"
          >
             <span class="px-75">
               <i class="far fa-file-archive"></i> </span> Download as ZIP
          </span>
        </div>
        <div class="dropdown-divider"></div>

        <div class="dropdown-item">
          <span
              id="dropboxButton"
              title="Choose one or more files from Dropbox"
              class="px-0 cursor-pointer dropdown-item d-flex text-indent-0 white-space-normal align-items-center"
              @click.prevent="uploadJobToDropbox"
          >
            <span class="px-75">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 43 40" version="1.1" width="15px">
                <path d="m12.5 0l-12.5 8.1 8.7 7 12.5-7.8-8.7-7.3zm-12.5 21.9l12.5 8.2 8.7-7.3-12.5-7.7-8.7 6.8zm21.2 0.9l8.8 7.3 12.4-8.1-8.6-6.9-12.6 7.7zm21.2-14.7l-12.4-8.1-8.8 7.3 12.6 7.8 8.6-7zm-21.1 16.3l-8.8 7.3-3.7-2.5v2.8l12.5 7.5 12.5-7.5v-2.8l-3.8 2.5-8.7-7.3z" fill="#007EE5"></path></svg>
            </span> {{'Upload to Dropbox'|trans}}
          </span>
        </div>

        <div class="dropdown-divider"></div>

        <div class="dropdown-item" @click.prevent="uploadJobToGdrive">
          <span
              id="gdriveButton" title="Choose one or more files from Google Drive"
              class="px-0 cursor-pointer dropdown-item d-flex text-indent-0 white-space-normal align-items-center">
            <span class="px-75"><svg width="15px" viewBox="0 0 87.3 78" xmlns="http://www.w3.org/2000/svg">
              <path d="m6.6 66.85 3.85 6.65c.8 1.4 1.95 2.5 3.3 3.3l13.75-23.8h-27.5c0 1.55.4 3.1 1.2 4.5z" fill="#0066da"></path>
              <path d="m43.65 25-13.75-23.8c-1.35.8-2.5 1.9-3.3 3.3l-25.4 44a9.06 9.06 0 0 0 -1.2 4.5h27.5z" fill="#00ac47"></path>
              <path d="m73.55 76.8c1.35-.8 2.5-1.9 3.3-3.3l1.6-2.75 7.65-13.25c.8-1.4 1.2-2.95 1.2-4.5h-27.502l5.852 11.5z" fill="#ea4335"></path>
              <path d="m43.65 25 13.75-23.8c-1.35-.8-2.9-1.2-4.5-1.2h-18.5c-1.6 0-3.15.45-4.5 1.2z" fill="#00832d"></path>
              <path d="m59.8 53h-32.3l-13.75 23.8c1.35.8 2.9 1.2 4.5 1.2h50.8c1.6 0 3.15-.45 4.5-1.2z" fill="#2684fc"></path>
              <path d="m73.4 26.5-12.7-22c-.8-1.4-1.95-2.5-3.3-3.3l-13.75 23.8 16.15 28h27.45c0-1.55-.4-3.1-1.2-4.5z" fill="#ffba00"></path></svg>
            </span> {{'Upload to Google Drive'|trans}}
        </span>
        </div>
      </div>

    </div>


  </div>
</template>
<script>
import store from './../../mixins/store.mixin'
import currentJob from './../../mixins/current_job.mixin'
import JobManager from "../../manager/JobManager";
import DownloadManager from "../../manager/DownloadManager";
import {JOB_STATE_ZIP} from "../../const/job.const";
import Gdrive from "../../util/Gdrive";
import DropboxSaver from "../../util/DropboxSaver";
import Analytics from "../../util/Analytics";

export default {
  name: "DownloadBtn",
  props: {},
  components: {},
  mixins: [
    store,
    currentJob,
  ],
  data() {
    return {
      dropdownActive: false
    };
  },
  mounted: function () {
  },
  created: function () {
    document.body.addEventListener('click', ((event) => {
      let dropdown = document.querySelector('.download-btn-box-big');
      if (dropdown.contains(event.target) === false) {
        this.dropdownActive = false;
      }
    }));
  },
  methods: {
    async downloadJobAsZip() {
      if (this.currentJob.state !== 'completed') {
        return;
      }
      this.dropdownActive = false;

      Analytics.send('result_download', 'primary_zip_dropdown', this.currentJob);

      await DownloadManager.downloadJobAsZip(this.currentJob.id);
    },
    async downloadJob() {
      if (this.currentJob.state !== 'completed') {
        return;
      }

      this.dropdownActive = false;

      if (this.currentJob.apiJob.output.length === 1) {
        Analytics.send('result_download', 'primary_single', this.currentJob);

        await DownloadManager.downloadOutput(this.currentJob.apiJob.output[0]);
        return;
      }

      Analytics.send('result_download', 'primary_zip', this.currentJob);

      await DownloadManager.downloadJobAsZip(this.currentJob.id);
    },
    uploadJobToGdrive() {
      if (this.currentJob.state !== 'completed') {
        return;
      }
      this.dropdownActive = false;
      Gdrive.uploadJob(this.currentJob);
    },
    uploadJobToDropbox() {
      if (this.currentJob.state !== 'completed') {
        return;
      }
      this.dropdownActive = false;
      DropboxSaver.uploadJob(this.currentJob);
    }
  },
  computed: {
    downloadLink() {
      if (this.currentJob.apiJob === null) {
        return '#';
      }

      if (this.currentJob.apiJob.output.length === 1) {
        return this.currentJob.apiJob.output[0].download_uri;
      }

      return '#';
    },
    processingDownload() {
      if (this.currentJob.state === JOB_STATE_ZIP) {return true;}
      if (this.loading) { return true ;}
      return false;
    }
  }
};
</script>
<style lang="scss" scoped>
#download-dropdown {
  position:absolute;
  background: white;
  top: 63px;
  border-left:2px solid #1266F1;
  border-bottom:2px solid #1266F1;
  border-right:2px solid #1266F1;
  width: 100%;
  border-radius: 0 0 9px 9px;
  overflow: hidden;
  z-index: 1;
}
.download-btn-main {
  padding: 0 20px;
  z-index: 5;
  flex: 1 1 auto;
  height: 100%;
  color: white;
}

.dropdown-item {
  padding: 10px 10px;
}
.download-btn-dropdown {
  border-left: 2px solid #1158cd;
  height: 100%;
  align-items: center;
  display: inline-flex;
  padding: 0 30px;
  user-select: none
}
.download-btn {
  padding: 0;
  background: #1266F1;
  color: white;
  height: 65px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 4px;
  gap: 10px;
  font-size: 17.5px;
  font-weight: 600;
  cursor: pointer;
  position:relative;

  &:hover {
    background: #1161e5;
  }
}

.disabled {
  opacity: .5;
  cursor: not-allowed;
}
</style>
